<template>
    <trax-ui-card :title="lang.polaris.form.files">

        <div v-show="loaded">

            <!-- Table -->
            <enac-atpl-dashboard-files-table :id="id" :endpoint="endpoint" :bus="bus" :editing="contextId">
            </enac-atpl-dashboard-files-table>

            <!-- Creation button -->

            <div class="mt-3" v-if="contextId">
                <button class="btn btn-round btn-default" @click="newFile">
                    {{ lang.polaris.form.add_file }}
                </button>
            </div>

        </div>

        <div v-show="!loaded">
            <b>{{ lang.polaris.dashboard.save_form_to_access_files }}</b>
            <div class="mt-2" v-if="contextId">
                <button class="btn btn-round btn-default" disabled>
                    {{ lang.polaris.form.add_file }}
                </button>
            </div>
        </div>

        <!-- Editing modal -->

        <trax-ui-modal-default :id="id+'-edit'" :bus="bus" :title="lang.polaris.form.add_file">
            <enac-atpl-dashboard-files-edit-popup :id="id" :bus="bus" :endpoint="endpoint">
            </enac-atpl-dashboard-files-edit-popup>
        </trax-ui-modal-default>

        <!-- Local toastr -->

        <trax-ui-toastr :id="id+'-toastr'" passed-label="1" :bus="bus">
        </trax-ui-toastr>

        <!-- Deletion confirm modal -->

        <trax-ui-modal-confirm :id="id+'-delete'" :title="lang.polaris.form.file_deletion" :bus="bus">
            {{ lang.polaris.form.confirm_delete_file_q }}
        </trax-ui-modal-confirm>

    </trax-ui-card>
</template>

<script>
    export default {
    
        props: {
            id: { default: 'enac-atpl-dashboard-files' },
            contextId: null,
        },

        data: function() {
            return {
                lang: lang,
                state: data.state,
                loaded: false,
                endpoint: app_url+"polaris/api/front/dashboard/registrations/"+data.registration.id+"/learning-units/"+data.item.id+"/learners/"+data.learner.id+"/files",
                contextBus: this.$bus,
                bus: new Vue()
            }
        },

        created: function() {
            this.contextBus.$on(this.contextId+'-states-data', this.setStates);
            this.contextBus.$on(this.contextId+'-states-updated', this.setStates);
        },

        mounted: function() {
            if (this.state) this.setStates({summary: this.state});
        },

        methods: {
            
            setStates: function(states) {
                if (!states.summary) {
                    this.loaded = false;
                    return;
                }
                this.loaded = true;
                this.bus.$emit(this.id+'-load-files');
            },

            newFile: function() {
                this.bus.$emit(this.id+'-edit-open');
            }

        }

    }
</script>
